import React, {Component} from 'react';
import {translate} from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';

var Config = require('../../config');

class SuppliesForm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);

		this.state = {
			name:"",
			code:"",
			barcode:"",
			presentation:"",
			presentation_list:[],
			unit:"",
			method:"",
			cost:"",
			min:"",
			max:"",
			type:"",
			tipos:[],
			caducidad:false
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'lookups?type=presentation&notRender=0', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					presentation_list: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=supplies_reagents_type&notRender=0', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					tipos: response
				});
			}
		});

		if(this.props.match.params.id !== undefined){
			this.setState({method: 'put'});

			fetch(Config.default.apiGateway.URL+'supplies_reagents?id='+this.props.match.params.id, {
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						name: response.name,
						code: response.code,
						barcode: response.barcode,
						presentation: response.presentation,
						unit: response.units,
						cost: response.cost_unit,
						min:response.min,
						max:response.max,
						type:response.type,
						caducidad:response.flag_expired_date
					});
				}
			});
		}else{
			this.setState({method: 'post'});
		}
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value});

		if(e.target.value !== ""){
			document.getElementById(e.target.id).classList.remove('error');
		}
	}

	onSave(){
		if(this.isValidForm()){
			var obj = {};
			var url = "";

			if(this.props.match.params.id !== undefined){
				obj.id = this.props.match.params.id;
				url = 'supplies_reagents?id='+this.props.match.params.id;
			}else{
				url = 'supplies_reagents';
			}

			obj.name = this.state.name;
			obj.code = this.state.code;
			obj.barcode = this.state.barcode;
			obj.presentation = this.state.presentation;
			obj.units = this.state.unit;
			obj.cost_unit = this.state.cost;
			obj.min = this.state.min;
			obj.max = this.state.max;
			obj.type = this.state.type;
			obj.flag_expired_date = this.state.caducidad;

			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+url, {
				method: this.state.method,
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res;
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					swal("Correcto", "Registro guardado correctamente.", 'success');
					this.onCancel();
				}
			});
		}else{
			swal('Error', 'Campos incompletos.', 'error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		//console.log(refName+' is required');
		var res = null;
		var control = document.getElementById(refName);

		if(control.required){
			if (control.value === "") {
				if(control !== null){
					control.classList.add('error');
				}
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
				}
				res = true;
			}
		}

		return res;
	}

	onCancel(){
		this.props.history.push('/supplies_reagents');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
                    {sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Insumos
					</h5>
				</div>

				<form noValidate>
					<fieldset className="col-xs-12">
						<legend>Insumos</legend>
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12"><span>(*) Campos Requeridos</span></div>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Nombre</span><span> (*)</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="text" className="form-control" name="name" id="name" required
									onChange={this.handleChange} value={this.state.name} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Código</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="text" className="form-control" name="code" id="code" 
									onChange={this.handleChange} value={this.state.code} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Código Barras</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="text" className="form-control" name="barcode" id="barcode" 
									onChange={this.handleChange} value={this.state.barcode} />
							</div>
						</div>
						
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Presentación</span><span> (*)</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<select className="form-control" name="presentation" id="presentation" 
									onChange={this.handleChange} value={this.state.presentation} required>
									<option value="">Seleccione...</option>
									{this.state.presentation_list.map((p, i)=>{
										return <option key={i} value={p.name}>
											{p.name}
										</option>
									})}
								</select>
							</div>
						</div>
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Unidades</span><span> (*)</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="number" className="form-control hour-input" name="unit" id="unit" 
									onChange={this.handleChange} value={this.state.unit} required/>
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Costo</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="number" className="form-control hour-input" name="cost" id="cost" 
									onChange={this.handleChange} value={this.state.cost} />
							</div>
						</div>

						<div className="col-xs-12 col-sm-7 col-sm-offset-3" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-1" style={{textAlign:"right", paddingRight:'0', marginRight:'-0.6%', left:'-2%'}}>
								<span className="span-min">Mínimo</span><span> (*)</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={{paddingLeft:'0', width:'17%'}}>
								<input type="number" className="form-control hour-input" name="min" id="min" 
									onChange={this.handleChange} value={this.state.min} required/>
							</div>
							<div className="col-xs-12 col-sm-1" style={{textAlign:"right", paddingRight:'0'}}>
								<span className="span-min">Máximo</span><span> (*)</span>
							</div>
							<div className="col-xs-12 col-sm-2">
								<input type="number" className="form-control hour-input" name="max" id="max" 
									onChange={this.handleChange} value={this.state.max} required/>
							</div>
						</div>
						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Tipo</span><span> (*)</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<select className="form-control" name="type" id="type" 
									onChange={this.handleChange} value={this.state.type} required>
									<option value="">Seleccione...</option>
									{this.state.tipos.map((p, i)=>{
										return <option key={i} value={p.key}>
											{p.name}
										</option>
									})}
								</select>
							</div>
						</div>

						<div className="col-xs-12 col-sm-9 col-sm-offset-2" style={{paddingTop:"10px"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Caducidad</span>
							</div>
							<div className="col-xs-12 col-sm-4">
								<input type="checkbox" name="caducidad" id="caducidad" 
									onChange={this.handleChange} value={this.state.caducidad} checked={this.state.caducidad}/>
							</div>
						</div>

							

						<div className="col-xs-12 col-sm-9" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onCancel} style={{margin:12}}/>
				        	</div>
				        </div>
					</fieldset>
				</form>
			</div>
		)
	}
}

export default translate('translations') (SuppliesForm);